'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import H4 from 'UIComponents/elements/headings/H4';
import MARKETING_ICON from 'bender-url!pricing-pages-unified-ui/img/productIcons/Marketing.svg';
import SALES_ICON from 'bender-url!pricing-pages-unified-ui/img/productIcons/Sales.svg';
import SERVICE_ICON from 'bender-url!pricing-pages-unified-ui/img/productIcons/Service.svg';
import { MARKETING, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import breakpoints from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
const ProductToIcon = {
  [MARKETING]: MARKETING_ICON,
  [SALES]: SALES_ICON,
  [SERVICE]: SERVICE_ICON
};
const StyledH4 = styled(H4).withConfig({
  displayName: "IconHeader__StyledH4",
  componentId: "sc-1nz22fg-0"
})(["text-align:left;", ""], breakpoints.mon491(_t || (_t = _`
    text-align:center;
`)));
export const IconHeader = ({
  WrapperComponent = StyledH4,
  feature,
  productLine,
  billingNameKey
}) => /*#__PURE__*/_jsx("div", {
  className: "m-bottom-7",
  children: /*#__PURE__*/_jsxs(WrapperComponent, {
    children: [/*#__PURE__*/_jsx(UIImage, {
      className: "display-inline-block m-right-3",
      src: ProductToIcon[productLine]
    }), /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricing-pages.products.${billingNameKey}.title`
      }), /*#__PURE__*/_jsx("span", {
        style: {
          color: BATTLESHIP
        },
        children: " | "
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricing-pages.features.${feature}.name`
      })]
    })]
  })
});